document.addEventListener("DOMContentLoaded", function () {
    const path = window.location.pathname;

    const sectionTitles = {
        "/guias-e-tutoriais/": "Guias e Tutoriais",
        "/contenido-formativo/": "Contenido Formativo",
        "/noticias-esportivas/": "Noticias Esportivas",
        "/actualizaciones-bet4-bet-br/": "Atualizações Bet4"
    };

    for (const key in sectionTitles) {
        if (path.startsWith(key)) {
            const titleElement = document.getElementById("dynamic-section-title");
            if (titleElement) {
                titleElement.innerHTML = `<h1 class="gh-article-title is-title">${sectionTitles[key]}</h1>`;
            }
            break;
        }
    }
});
